// Lib
import { combineReducers } from 'redux-immutable';
import * as Immutable from 'immutable';

// Reducers
import debugToolReducer from './store/debugToolReducer';
import elementPlaceholderDebugToolReducer from './elementPlaceholders/elementPlaceholderDebugToolReducer';

// Constants
import { DEBUG_TOOL_TOGGLE, DEBUG_TOOLBAR_SET_ENABLED, ENABLE_DEBUG_TOOLS } from './debugConstants';
import { DEBUG_ELEMENT_PLACEHOLDER_NAME } from './elementPlaceholders/PlaceholderDebugToolConstants';

const enabledReducer = (state = false, action) => {
    switch (action.type) {
        case ENABLE_DEBUG_TOOLS:
            return true;
        case DEBUG_TOOLBAR_SET_ENABLED:
            return action.enabled ? true : state;
        default:
            return state;
    }
};

const toolbarReducer = (state = false, action) => {
    switch (action.type) {
        case DEBUG_TOOLBAR_SET_ENABLED:
            return action.enabled;
        default:
            return state;
    }
};

const initialEnabledTools = Immutable.fromJS({});

const enabledToolsReducer = (state = initialEnabledTools, action) => {
    switch (action.type) {
        case DEBUG_TOOL_TOGGLE:
            return state.set(action.toolName, action.enabled);
        default:
            return state;
    }
};

const debugReducer = combineReducers({
    enabled: enabledReducer,
    toolbar: toolbarReducer,
    enabledTools: enabledToolsReducer,
    tools: debugToolReducer,
    [DEBUG_ELEMENT_PLACEHOLDER_NAME]: elementPlaceholderDebugToolReducer,
});

const initialState = Immutable.Map();
const wrappedDebugReducer = (state = initialState, action) => {
    if (action.type !== ENABLE_DEBUG_TOOLS && !state.get('enabled')) return state;
    return debugReducer(state, action);
};

export default wrappedDebugReducer;
